import { login } from '@/api/login';
import { getToken, setToken } from '@/utils/auth';
import { COMMON } from '@/api/common';
const user = {
  state: {
    token: getToken(),
    userInfo: {},
    adminToken: ''
    // guideDialog: false // 引导用户去到新版弹框
    // name: '',
    // avatar: '',
    // roles: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    // SET_NAME: (state, name) => {
    //   state.name = name;
    // },
    // SET_AVATAR: (state, avatar) => {
    //   state.avatar = avatar;
    // },
    // SET_ROLES: (state, roles) => {
    //   state.roles = roles;
    // }
    SET_USER: (state, userInfo) => {
      state.userInfo = userInfo;
    },
    SET_ADMIN_TOKEN: (state, token) => {
      state.adminToken = token;
    }
    // SET_GUIDE_DIALOG: (state, guideDialog) => {
    //   state.guideDialog = guideDialog
    //   console.log('SET_GUIDE_DIALOG')
    //   console.log(guideDialog)
    // }
  },

  actions: {
    // 登录
    // Login({ commit }, userInfo) {
    //   const email = userInfo.email.trim();
    //   return new Promise((resolve, reject) => {
    //     login(email, userInfo.password).then(response => {
    //       const data = response.data;
    //       setToken(data.token);
    //       commit('SET_TOKEN', data.token);
    //       resolve();
    //     }).catch(error => {
    //       reject(error);
    //     });
    //   });
    // },
    // 自定义登陆
    Login({ commit }, userInput) {
      // 暂时用cookie获取完成登陆
      return new Promise((resolve, reject) => {
        login().then(res => {
          if (res.success) {
            window.sessionStorage.setItem('adminToken', res.token);
            window.sessionStorage.setItem('refreshToken', res.refreshToken);
            setToken(res.token);
            commit('SET_ADMIN_TOKEN', res.token);
            resolve(res.success);
          } else {
            reject(res)
          }
        }).catch(error => {
          console.log('login error', error)
          reject(error);
        });
      })
    },

    // 获取用户信息
    // GetInfo({ commit, state }) {
    //   return new Promise((resolve, reject) => {
    //     getInfo(state.token).then(response => {
    //       const data = response.data;
    //       commit('SET_ROLES', data.role);
    //       commit('SET_NAME', data.name);
    //       commit('SET_AVATAR', data.avatar);
    //       resolve(response);
    //     }).catch(error => {
    //       reject(error);
    //     });
    //   });
    // },
    //   获取商户个人信息
    GetUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        COMMON.getUserInfo().then(res => {
          commit('SET_USER', res);
          // 如果代理商 不是水果系统 才显示弹框
          // if (Number(res.agentId) !== 4784847) {
          //   commit('SET_GUIDE_DIALOG', true)
          // }
          resolve(res);
        }).catch(err => {
          reject(err);
        })
      })
    }
    // 登出
    // LogOut({ commit, state }) {
    //   return new Promise((resolve, reject) => {
    //     logout(state.token).then(() => {
    //       commit('SET_TOKEN', '');
    //       commit('SET_ROLES', []);
    //       removeToken();
    //       resolve();
    //     }).catch(error => {
    //       reject(error);
    //     });
    //   });
    // },

    // 前端 登出
    // FedLogOut({ commit }) {
    //   return new Promise(resolve => {
    //     commit('SET_TOKEN', '');
    //     removeToken();
    //     resolve();
    //   });
    // }
  }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js